import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import 'rxjs/add/operator/toPromise';
import {Dog} from '../../../classes/dog';
import config from '../../../config';
import {Service} from "../../../classes/service";
import {ServiceLog} from "../../../classes/serviceLog";
import {Note} from "../../../classes/note";
import {User} from "../../../classes/user";
import {FileLog} from "../../../classes/fileLog";
import {FileData} from "../../../classes/fileData";

@Injectable()
export class kanFilesService {
    constructor(private http: HttpClient) {
    }

    public getContainer(model: string, containerName: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get(`${config.apiRootUrl}/api/${model}/${containerName}`)
                .toPromise()
                .then((response: any) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public createContainer(model: string, containerName: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.getContainer(model, containerName)
                .then((container) => {
                    resolve(container);
                })
                .catch((error) => {
                    this.http.post(`${config.apiRootUrl}/api/${model}`, {name: containerName})
                        .toPromise()
                        .then((response: any) => {
                            resolve(response);
                        })
                        .catch((error) => {
                            reject(error);
                        });
                });
        });
    }

    public uploadFile(model: string, containerName: string, file: File, fileName: string = null, type: string = ''): Promise<FileData> {
        return new Promise((resolve, reject) => {
            this.createContainer(model, containerName)
                .then(() => {
                    fileName = fileName || `${containerName}${Date.now()}.${file.name.split('.').pop().toLowerCase()}`;
                    let formData = new FormData();
                    formData.append(file.toString(), file, fileName);
                    this.http.post(`${config.apiRootUrl}/api/${model}/${containerName}/upload`, formData)
                        .toPromise()
                        .then((response: any) => {
                            let fileData = {
                                name: file.name,
                                serverName: fileName,
                                container: containerName,
                                path: `${type.toLowerCase()}/${containerName}/${encodeURI(fileName)}`,
                                type: file.type,
                                model: model,
                                size: file.size
                            };
                            resolve(fileData as FileData);
                        })
                        .catch((error) => {
                            reject(error);
                        });
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public deleteFile(model: string, containerName: string, fileName: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.delete(`${config.apiRootUrl}/api/${model}/${containerName}/files/${fileName}`)
                .toPromise()
                .then((response: any) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public getFileLogs(filter): Promise<FileLog[]> {
        return new Promise((resolve, reject) => {
            let params = new HttpParams().set('filter', JSON.stringify(filter));
            this.http.get(`${config.apiRootUrl}/api/fileLogs`, {params: params})
                .toPromise()
                .then((response: any) => {
                    let fileLogs = response.map((fileLog) => {
                        return fileLog;
                    });
                    resolve(fileLogs as FileLog[]);
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    public addFileLog(fileLog: FileLog, file: File, fileName = null): Promise<FileLog> {
        return new Promise((resolve, reject) => {

            let model;
            let containerName;
            switch (fileLog.type) {
                case 'DOG':
                    model = 'dogFiles';
                    containerName = fileLog.dogId;
                    break;
                case 'USER':
                    model = 'userFiles';
                    containerName = fileLog.userId;
                    break;
                case 'MAIL':
                    model = 'mailFiles';
                    containerName = String(Math.floor(Math.random() * 100000));
                    break;
            }

            this.uploadFile(model, containerName, file, fileName, fileLog.type)
                .then((fileData) => {
                    fileLog.file = fileData;
                    this.http.post(`${config.apiRootUrl}/api/fileLogs`, fileLog)
                        .toPromise()
                        .then((response: any) => {
                            resolve(response as FileLog);
                        })
                        .catch((error: any) => {
                            reject(error);
                        });
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    public updateFileLog(fileLog: FileLog): Promise<FileLog> {
        return new Promise((resolve, reject) => {
            this.http.patch(`${config.apiRootUrl}/api/fileLogs/${fileLog.id}`, fileLog)
                .toPromise()
                .then((response: any) => {
                    resolve(response as FileLog);
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    public removeFileLog(fileLog: FileLog): Promise<FileLog> {
        return new Promise((resolve, reject) => {
            this.deleteFile(fileLog.file.model, fileLog.file.container, fileLog.file.serverName)
                .then(()=>{
                    this.http.delete(`${config.apiRootUrl}/api/fileLogs/${fileLog.id}`)
                        .toPromise()
                        .then((response: any) => {
                            resolve();
                        })
                        .catch((error: any) => {
                            reject(error);
                        });
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/modules/services/services/files.ts